<div class="card-inner-main-div">
  <div class="card-main-title border-bottom">
    <h4 class="card-title">{{ 'Samples' | translate }} <span class="small-light-text d-block">{{ 'Contribution to exposures for this SEG' | translate }}</span></h4>
  </div>
  <div class="tableColStyle without-borders-table">
    @if (loadingExposureTaskSamples) {
      <div class="comments-loader">
        <img src="assets/images/loader.gif">
      </div>
    }
    @if (!loadingExposureTaskSamples) {
      <div class="table-responsive">
        <table class="table table-striped" matSort (matSortChange)="sortExposureTaskSamples($event)"
          matSortDisableClear>
          <thead>
            <tr>
              <th scope="col" mat-sort-header="sampleNumber">
                <a>{{ 'Sample #' | translate }}</a>
              </th>
              <th scope="col" mat-sort-header="createdDate">
                <a>{{ 'Date' | translate }}</a>
              </th>
              <th scope="col" mat-sort-header="segName">
                <a>{{ 'SEG' | translate }}</a>
              </th>
              <th scope="col" mat-sort-header="taskContributionPercent">
                <a>{{ 'Task Exposure contribution %' | translate }}</a>
              </th>
              <th scope="col" mat-sort-header="timeOnShiftMins">
                <a>{{ 'Time On Shift' | translate }}</a>
              </th>
              <th scope="col" mat-sort-header="orgLevelName">
                <a>{{ 'Site' | translate }}</a>
              </th>
              <th scope="col" mat-sort-header="result">
                <a>{{ 'Result' | translate }}</a>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (sample of exposureTaskSamples; track trackByIndex($index)) {
              <tr>
                <td><a (click)="redirectToSample(sample.sensorAssignmentId)">{{sample.sampleNumber}}</a></td>
                <td>{{(sample.createdDate * 1000) | dateFormat }}</td>
                <td>{{sample.segName}}</td>
                <td>
                  <div class="percentage-txt-div w-100">{{sample.taskContributionPercent}}%
                  </div>
                </td>
                <td>{{sample.timeOnShiftMins}} min{{sample.timeOnShiftMins > 1 ? 's':''}}</td>
                <td>{{sample.orgLevelName}}</td>
                <td>{{sample.result}} {{sample.resultUnit}}</td>
              </tr>
            }
            @if (exposureTaskSamples && !exposureTaskSamples.length) {
              <tr>
                <td colspan="7" class="no-data-available with-padding">{{errorMessage}}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>